import createVueComponent from '../createVueComponent';

const ArrowDownLeftFromCircle = createVueComponent(
  'ArrowDownLeftFromCircleIcon',
  [
    ['path', { d: 'M2 12a10 10 0 1 1 10 10', key: '1yn6ov' }],
    ['path', { d: 'm2 22 10-10', key: '28ilpk' }],
    ['path', { d: 'M8 22H2v-6', key: 'sulq54' }],
  ],
);

export default ArrowDownLeftFromCircle;
